import { CoinGeckoClient, type HttpResponse } from 'coingecko-api-v3'

/**
 * coingecko-api-v3 가 node.js 를 기반으로 만들어져서 요청시 node 의 https built-in 모듈을 사용하기 때문에 브라우저에서 사용시 비정상 동작함
 * 때문에 CoinGeckoClient 의 private method 인 httpGet을 fecth 를 사용하게 수정
 */
type TypeHttpGetFunction = <T>(url: string) => Promise<HttpResponse<T | any>>
;((CoinGeckoClient.prototype as any).httpGet as TypeHttpGetFunction) =
  async function (url) {
    try {
      const res = await fetch(url)
      const headers: Record<string, string> = {}
      res.headers.forEach((value, key) => {
        headers[key] = value
      })
      return {
        data: await res.json(),
        statusCode: res.status,
        headers,
      }
    } catch {
      return {
        data: null,
        statusCode: 500,
        headers: {},
      }
    }
  }
